import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from '../../services/router-utils';
import SearchInput from '../../components/search-input';

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onClick: query => dispatch => {
        dispatch(
          push({
            pathname: '/search/posts',
            query: { query },
          })
        );
      },
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(SearchInput);



// WEBPACK FOOTER //
// ./app/containers/search-input/search-input.js